import { useLocation } from 'react-router-dom';
import { LayoutDashboard, Sparkles, Settings, User, LogOut } from 'lucide-react';
import { useAuth } from 'components/context/AuthContext';
import './GrowthPartnerDock.css';

// GPs cuya marca puede usar Bebo IA desde el dock (ecom). WTC (lead_gen) no lo ve.
const BEBO_BRANDS = new Set([1666 /* Barraca */, 1589 /* Búho */]);

const BASE_ITEMS = [{ icon: LayoutDashboard, label: 'Panel', path: '/mi-panel' }];
const TAIL_ITEMS = [
  { icon: Settings, label: 'Mi configuración', path: '/profile' },
  { icon: User, label: 'Usuario', path: '/profile/users' },
];
const BEBO_ITEM = { icon: Sparkles, label: 'Bebo IA', path: '/admin/bebo' };

/**
 * Dock de navegación para usuarios Growth Partner: menú vertical flotante a la
 * izquierda, estilo dock de macOS (glass translúcido, bordes 20px, íconos que se
 * agrandan al hover). Reemplaza al Sidebar para estos usuarios. La navegación la
 * resuelve el padre (`onNavigate`); el cierre de sesión usa el AuthContext.
 */
export default function GrowthPartnerDock({ onNavigate }) {
  const location = useLocation();
  const { auth, logout } = useAuth();
  const showBebo = BEBO_BRANDS.has(auth?.user?.active_brand_id);
  const items = [...BASE_ITEMS, ...(showBebo ? [BEBO_ITEM] : []), ...TAIL_ITEMS];
  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <nav className="gpdock" aria-label="Navegación">
      <div className="gpdock-inner">
        {items.map(({ icon: Icon, label, path }) => (
          <button
            key={path}
            type="button"
            className={`gpdock-item ${isActive(path) ? 'active' : ''}`}
            onClick={() => onNavigate(path)}
            aria-label={label}
          >
            <Icon size={22} strokeWidth={1.8} aria-hidden="true" />
            <span className="gpdock-tip">{label}</span>
          </button>
        ))}
        <div className="gpdock-sep" />
        <button type="button" className="gpdock-item" onClick={logout} aria-label="Cerrar sesión">
          <LogOut size={22} strokeWidth={1.8} aria-hidden="true" />
          <span className="gpdock-tip">Cerrar sesión</span>
        </button>
      </div>
    </nav>
  );
}
